module.exports = __webpack_public_path__ + "static/media/camper.1e02e1db.png";